export default __webpack_public_path__ + "static/media/success.4cac27b4.png";